
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wellness",
      function () {
        return require("private-next-pages/wellness.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wellness"])
      });
    }
  